import styled, { css } from 'styled-components';
import { AllieButton } from '../../../Buttons/Button';

const commonStyles = css`
  --color: var(--allie-color-neutral-60);
  --height: 24px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --border-color: none;
  --border-width: 0;
  --border-radius: 0;
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 6px 4px;
  .allie-text-button-small {
    font-size: 14px;
  }
`;

export const StyledIconButton = styled(AllieButton)`
  background: var(--allie-color-light-main);
  margin: 0;

  ${commonStyles} &:hover {
    color: var(--allie-color-neutral-main);
  }
`;
export const StyledDownloadIcon = styled.div`
  display: flex;
  height: 20px;
  width: 20px;

  .stroke-icon {
    stroke: #000;
  }

  & svg {
    width: 20px;
    height: 20px;
  }
`;
